module.exports = __webpack_public_path__ + "static/media/kevin_antony.adcc837a.png";